// extracted by mini-css-extract-plugin
export default {"heading":"ColorPicker_heading__ewdBz","colorPickerBox":"ColorPicker_colorPickerBox__bbLiH","SketchPicker":"ColorPicker_SketchPicker__hhTDn"};